// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Information_wrapper__2y3JM","saveAlert":"Information_saveAlert__1hj2G"};